import React, { FC } from 'react';
import styled from 'styled-components';

import { getStyledThemeColor } from '@portals/utils';

interface ActionsProps {
  onClick: () => void;
  displayEditModeBtn: boolean;
}

const Actions: FC<ActionsProps> = ({ onClick, displayEditModeBtn }) => (
  <Container>
    <div className="status-wrapper">
      <div className="indicator connected" /> Connected
    </div>

    {displayEditModeBtn ? (
      <div className="change-domain" onClick={onClick}>
        Change domain
      </div>
    ) : null}
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .status-wrapper {
    display: flex;
    align-items: center;
    font-size: 12px;

    .indicator {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 6px;

      &.connected {
        background-color: ${getStyledThemeColor('lightGreen')};
      }

      &.disconnected {
        background-color: ${getStyledThemeColor('red')};
      }
    }
  }

  .change-domain {
    color: ${getStyledThemeColor('primary')};
    font-size: 12px;
    cursor: pointer;
  }
`;

export default Actions;
